export default "__VITE_ASSET__CW0CudLI__"